export default rolesRun

/** @ngInject */
function rolesRun($cookies, $q, PermPermissionStore, ApiService, UserStatus) {
    PermPermissionStore.definePermission('user', () => Boolean($cookies.get('ssoStatus')))
    PermPermissionStore.definePermission('anonymous', () => !$cookies.get('ssoStatus'))
    return PermPermissionStore.definePermission('client', () => {
        if (($cookies.get('ssoStatus'))) {
            const deferred = $q.defer()
            ApiService.fetchUserInfo()
            .then((userInfo) => {
                if ([UserStatus.activeWithContracts, UserStatus.activeFinishedContracts].indexOf(userInfo.status) > -1) {
                    localStorage.hideDashboard = true
                    return deferred.resolve()
                }
                return deferred.reject()
            })
            .catch((error) => deferred.reject())
            return deferred.promise
        }
        return false
    })
}



// WEBPACK FOOTER //
// ./src/config/roles.js